import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { env } from 'shared/apollo/client';
import { invokeLambda } from 'shared/services/lambda';
import { useClient } from 'shared/apollo';
import AccountEditor from 'shared/no-auth/components/AccountEditor/AccountEditor';
import checkPassword from 'shared/no-auth/components/AccountEditor/checkPassword';

const roles = {
  admin: 'Admin',
  poweruser: 'Power User',
  basic: 'Basic',
  guest: 'Guest',
};

const getRole = role => roles[role] || role;

const NewUser = ({
  isNewUserDrawerOpen,
  handleNewUserDrawerClose,
  accountId,
  listUsers,
  onDirty,
}) => {
  return (
    <NewUserInner
      accountId={accountId}
      title="New User"
      refreshUserList={listUsers}
      onDirty={onDirty}
      handleClose={handleNewUserDrawerClose}
    />
  );
};

export default NewUser;

export const NewUserInner = ({onDirty,
  accountId,
  title,
  extraButtons,
  refreshUserList = () => { /* noop */ },
  handleClose = () => { /* noop */ } }
) => {
  const userAttributes = {};
  const { push } = useHistory();
  const client = useClient();

  const [updateCompleted, setUpdateCompleted] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleSubmit = useCallback(async ({ password, confirm_password, ...rest }) => {
    if (!checkPassword(password)) {
      return false;
    }
    if (password !== confirm_password) {
      alert('New Password and Confirm New Password must match');
      return false;
    }
    try {
      const { data } = await client.mutate({
        mutation: newUserMutation,
        variables: {
          email: rest.email,
          password,
          account_id: accountId,
          firstName: rest['given_name'],
          lastName: rest['family_name'],
          userType: rest['custom:type'],
          title: rest['custom:title'],
          phone: rest['phone_number'],
          pronoun: rest['custom:pronoun'],
        },
      });
      await invokeLambda('users/createUser', {
        env,
        username: rest.email,
        password,
        desiredDeliveryMediums: ['EMAIL'],
        userAttributes: {
          ...rest,
          'custom:user_id': String(data.newUser.userId),
          'custom:account_id': accountId
        }
      });
      setUpdateCompleted(`User for ${rest.email} has been created successfully!`);
      refreshUserList();
      setTimeout(() => {
        handleClose();
      }, 2000);
    } catch (err) {
      alert(err.message || err);
      return false;
    }
  }, [accountId, push, client]);

  const handleEmailVerified = useCallback(() => { /* noop */ }, []);

  return (
    <AccountEditor
      mode="new"
      submitButtonTitle="Create User"
      userAttributes={userAttributes}
      handleSubmit={handleSubmit}
      handleEmailVerified={handleEmailVerified}
      title={title}
      extraButtons={extraButtons}
      updateCompleted={updateCompleted}
      isDrawer
      onDirty={onDirty}
    />
  );
};

const newUserMutation = gql`mutation newUser(
  $email: String!,
  $password: String,
  $firstName: String!,
  $lastName: String!,
  $title: String,
  $userType: String!,
  $phone: String,
  $accountId: Int,
  $pronoun: String
) {
  newUser(
    email: $email,
    password: $password,
    firstName: $firstName,
    lastName: $lastName,
    title: $title,
    userType: $userType,
    phone: $phone,
    accountId: $accountId,
    pronoun: $pronoun
  ) {
    userId
  }
}`;